<div class="responsive-card">
  <div class="d-flex">
    <div class="responsive-card-title" i18n>Lump Sum Payment Details</div>
  </div>

  <div class="d-flex flex-column gap-1 mt-4">
    <div class="section-label" i18n>Upcoming</div>
    <div class="upcoming-payment-card">
      <div class="payment-date flex-grow-1">{{ lumpSumPayment.formattedDesiredPaymentDate | date : 'MMMM yyyy' }}</div>
      <div class="payment-amount">{{ lumpSumPayment.paymentAmount | currency }}</div>
    </div>
  </div>
</div>
